import React from 'react';
import { EventItem } from '../../types/event';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faEdit, 
  faTrash, 
  faImage, 
  faClock, 
  faMapMarkerAlt, 
  faCalendarAlt,
  faFileAlt
} from '@fortawesome/free-solid-svg-icons';
import './EventListItem.css';

interface EventListItemProps {
  event: EventItem;
  onEdit: (event: EventItem) => void;
  onDelete: (id: string) => void;
  onViewApplications?: (eventId: string) => void;
  submitting: boolean;
}

const EventListItem: React.FC<EventListItemProps> = ({ 
  event, 
  onEdit, 
  onDelete, 
  onViewApplications,
  submitting 
}) => {
  const handleListItemClick = (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    // Prevent click if user clicks on an action button
    if (
      (e.target as HTMLElement).closest('.eli-event-actions') ||
      (e.target as HTMLElement).closest('button')
    ) {
      return;
    }
    if (onViewApplications) {
      onViewApplications(event.id);
    }
  };

  return (
    <li className="eli-event-list-item" onClick={handleListItemClick} tabIndex={onViewApplications ? 0 : -1} style={{ cursor: onViewApplications ? 'pointer' : 'default' }}>
      <div className="eli-event-image">
        {event.imageUrl ? (
          <div 
            className="eli-event-image-container" 
            style={{ 
              backgroundImage: `url(${event.imageUrl})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          />
        ) : (
          <div className="eli-no-image-container">
            <FontAwesomeIcon icon={faImage} className="eli-no-image-icon" />
          </div>
        )}
      </div>
      <h3 className="eli-event-title" title={event.title}>
        {event.title}
      </h3>
      <div className="eli-event-details">
        <div className="eli-event-details-inner">
          <span className="eli-event-date">
            <FontAwesomeIcon icon={faCalendarAlt} style={{ color: '#9c27b0' }} /> {event.date}
          </span>
          <span className="eli-event-time">
            <FontAwesomeIcon icon={faClock} style={{ color: '#2196F3' }} /> {event.startTime.doorsOpen}
          </span>
          <span className="eli-event-location">
            <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: '#4CAF50' }} /> {event.address}
          </span>
        </div>
      </div>
      <div className="eli-event-actions">
        {onViewApplications && (
          <button
            className="eli-applications-button"
            title="Applications"
            onClick={() => onViewApplications(event.id)}
          >
            <FontAwesomeIcon icon={faFileAlt} />
            <span className="eli-button-text">Applications</span>
          </button>
        )}
        <button
          className="eli-view-button"
          title="Edit Event"
          onClick={() => onEdit(event)}
        >
          <FontAwesomeIcon icon={faEdit} />
          <span className="eli-button-text">Edit</span>
        </button>
        <button
          className="eli-approve-button"
          title="Delete Event"
          onClick={() => onDelete(event.id)}
          disabled={submitting}
        >
          <FontAwesomeIcon icon={faTrash} />
          <span className="eli-button-text">Delete</span>
        </button>
      </div>
    </li>
  );
};

export default EventListItem;
